import { Typography } from '@mui/material';
import CalculateIcon from '@mui/icons-material/CalculateOutlined';

const PricingTitle = () => {
	return (
		<Typography
			variant='h4'
			sx={{
				mb: 3,
				display: 'flex',
				alignItems: 'center',
				gap: 0.5,
				'& svg': {
					fontSize: '1.4em',
					position: 'relative',
					top: '1px',
					marginLeft: '2px',
				},
			}}
		>
			<CalculateIcon />
			Pricing
		</Typography>
	);
};

export default PricingTitle;
